import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import footerLogo from '../assets/img/footer-logo.png';

const Footer = () => {
    return (
        <footer className="main-footer">
            <div className="footer-details">
                <div className="container c_container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-about">
                                <Link to="/testigo/home">
                                    <img src={footerLogo} alt="logo" /> </Link>
                                <p className="para-16 text-white">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-address">
                                <p className="para-16 text-white">105, The Jewel building, Tata Road No.3, Opera house Charniroad East. Mumbai 400004, MH, INDIA</p>
                                <p className="para-16 text-white">Ph: <Link to="tel:9123456789">(+91) 9123 45 67 89</Link></p>
                                <p className="para-16 text-white">Fax: <Link to="tel:9123456789">(+91) 9123 45 67 89</Link></p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-phone">
                                <p className="para-16 text-white">Toll Free: <Link to="tel:180010001000">1800 1000 1000</Link></p>
                                <p className="para-16 text-white">Ph: <Link to="tel:9123456789">(+91) 9123 45 67 89</Link></p>
                                <p className="para-16 text-white">Fax: <Link to="tel:9123456789" className="reset-color">(+91) 9123 45 67 89</Link></p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-phone">
                                <p className="para-16 text-white"><Link to="mailto:customercare@testigoxrayindia.com">customercare@testigoxrayindia.com</Link></p>
                                <Link href="#" className="btn custom-btn2">Contact Us</Link>
                                <ul className="footer-social">
                                    <li><Link to="#"><i className="fa fa-facebook" /></Link></li>
                                    <li><Link to="#"><i className="fa fa-twitter" /></Link></li>
                                    <li><Link to="#"><i className="fa fa-google-plus" /></Link></li>
                                    <li><Link to="#"><i className="fa fa-youtube" /></Link></li>
                                    <li><Link to="#"><i className="fa fa-instagram" /></Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="footer-menu">
                        <div className="row">
                            <div className="col-12">
                                <div className="footer-cities">
                                    <p><span>Cities We Serve : </span>Mumbai, Delhi, Chennai, Kolkata, Pune, Ahemdabad, Hyderabad, Jaipur, Indore, Chandigarh, Ujjain.</p>
                                </div>
                                <ul className="nav justify-content-center">
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/testigo/home">Home</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/testigo/services">Services</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/testigo/about">About Us</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="#">Branch Locations</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="#">Promotions &amp; News</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="#">Careers</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="#">Blogs</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="#">Social Media</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/testigo/contact">Contact Us</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-copyright">
                <div className="container c_container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 order-md-0 order-1">
                            <p className="para-16 text-white mb-0">@ Testigo X-Ray, All Rights Reserved.</p>
                        </div>
                        <div className="col-lg-4 col-md-6 offset-lg-4 order-md-0 order-0">
                            <p className="para-16 text-white text-md-end mb-md-0">
                                <NavLink to="#" className="text-reset text-decoration-none">Privacy Policy</NavLink> I <NavLink href="#" className="text-decoration-none text-reset">Disclaimer</NavLink> I <NavLink to="#" className="text-reset text-decoration-none">Cookie Policy</NavLink></p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;